import "./ButtonV2.css";

const ButtonV2 = ({ text, onPress }) => {
  return (
    <button className="button-v2" onClick={() => onPress?.(text)}>
      {text}
      <div className="arrow-wrapper">
        <div className="arrow"></div>
      </div>
    </button>
  );
};

export default ButtonV2;
